import Tabs from './Tabs';
import TabList from './TabList';
import TabPanel from './TabPanel';
import Tab from './Tab';
import { SHOPPING_TABS, SHOPPING_TABS_CONTENT } from './constants';

export { Tabs, Tab, TabList, TabPanel, SHOPPING_TABS, SHOPPING_TABS_CONTENT };
